export const BRAND_KIT_SAMPLE_VIDEO_URL = '/videos/sample-video-vertical.mp4';
export const BRAND_KIT_SAMPLE_VIDEO_END_TIME = 37.49;

// Hardcoded transcription segments for the brand kit preview.
// These match the sample videos at /videos/sample-video-horizontal.mp4 and
// /videos/sample-video-vertical.mp4 (~37.5s duration).
// Format: Segment[][] as expected by ProjectPreview's transcriptionSegments prop.

const words = [
  { word: "Você", start: 0.0, end: 0.3 },
  { word: "já", start: 0.3, end: 0.5 },
  { word: "parou", start: 0.5, end: 0.8 },
  { word: "pra", start: 0.8, end: 0.95 },
  { word: "pensar", start: 0.95, end: 1.3 },
  { word: "como", start: 1.3, end: 1.55 },
  { word: "os", start: 1.55, end: 1.7 },
  { word: "melhores", start: 1.7, end: 2.1 },
  { word: "criadores", start: 2.1, end: 2.6 },
  { word: "de", start: 2.6, end: 2.75 },
  { word: "conteúdo", start: 2.75, end: 3.3 },
  { word: "conseguem", start: 3.3, end: 3.8 },
  { word: "crescer", start: 3.8, end: 4.2 },
  { word: "tão", start: 4.2, end: 4.5 },
  { word: "rápido", start: 4.5, end: 5.0 },
  { word: "A", start: 5.2, end: 5.35 },
  { word: "verdade", start: 5.35, end: 5.8 },
  { word: "é", start: 5.8, end: 5.95 },
  { word: "que", start: 5.95, end: 6.1 },
  { word: "eles", start: 6.1, end: 6.35 },
  { word: "usam", start: 6.35, end: 6.7 },
  { word: "ferramentas", start: 6.7, end: 7.3 },
  { word: "inteligentes", start: 7.3, end: 7.9 },
  { word: "pra", start: 7.9, end: 8.1 },
  { word: "automatizar", start: 8.1, end: 8.8 },
  { word: "o", start: 8.8, end: 8.95 },
  { word: "processo", start: 8.95, end: 9.5 },
  { word: "Imagina", start: 9.8, end: 10.3 },
  { word: "poder", start: 10.3, end: 10.7 },
  { word: "transformar", start: 10.7, end: 11.3 },
  { word: "um", start: 11.3, end: 11.45 },
  { word: "vídeo", start: 11.45, end: 11.9 },
  { word: "longo", start: 11.9, end: 12.3 },
  { word: "em", start: 12.3, end: 12.45 },
  { word: "vários", start: 12.45, end: 12.9 },
  { word: "clipes", start: 12.9, end: 13.4 },
  { word: "virais", start: 13.4, end: 13.9 },
  { word: "com", start: 14.1, end: 14.3 },
  { word: "legendas", start: 14.3, end: 14.9 },
  { word: "perfeitas", start: 14.9, end: 15.5 },
  { word: "e", start: 15.5, end: 15.65 },
  { word: "uma", start: 15.65, end: 15.85 },
  { word: "identidade", start: 15.85, end: 16.5 },
  { word: "visual", start: 16.5, end: 17.0 },
  { word: "profissional", start: 17.0, end: 17.7 },
  { word: "É", start: 18.0, end: 18.15 },
  { word: "exatamente", start: 18.15, end: 18.8 },
  { word: "isso", start: 18.8, end: 19.1 },
  { word: "que", start: 19.1, end: 19.3 },
  { word: "o", start: 19.3, end: 19.4 },
  { word: "Autoclipper", start: 19.4, end: 20.1 },
  { word: "faz", start: 20.1, end: 20.4 },
  { word: "por", start: 20.4, end: 20.6 },
  { word: "você", start: 20.6, end: 20.9 },
  { word: "Com", start: 21.2, end: 21.45 },
  { word: "inteligência", start: 21.45, end: 22.1 },
  { word: "artificial", start: 22.1, end: 22.7 },
  { word: "a", start: 22.7, end: 22.85 },
  { word: "gente", start: 22.85, end: 23.15 },
  { word: "identifica", start: 23.15, end: 23.8 },
  { word: "os", start: 23.8, end: 23.95 },
  { word: "momentos", start: 23.95, end: 24.5 },
  { word: "mais", start: 24.5, end: 24.75 },
  { word: "impactantes", start: 24.75, end: 25.5 },
  { word: "do", start: 25.5, end: 25.7 },
  { word: "seu", start: 25.7, end: 25.9 },
  { word: "vídeo", start: 25.9, end: 26.4 },
  { word: "E", start: 26.7, end: 26.85 },
  { word: "o", start: 26.85, end: 26.95 },
  { word: "melhor", start: 26.95, end: 27.3 },
  { word: "de", start: 27.3, end: 27.45 },
  { word: "tudo", start: 27.45, end: 27.8 },
  { word: "é", start: 27.8, end: 27.95 },
  { word: "que", start: 27.95, end: 28.1 },
  { word: "você", start: 28.1, end: 28.4 },
  { word: "personaliza", start: 28.4, end: 29.1 },
  { word: "cada", start: 29.1, end: 29.4 },
  { word: "detalhe", start: 29.4, end: 29.9 },
  { word: "Cores", start: 30.2, end: 30.6 },
  { word: "fontes", start: 30.6, end: 31.0 },
  { word: "logo", start: 31.0, end: 31.3 },
  { word: "legendas", start: 31.3, end: 31.9 },
  { word: "tudo", start: 31.9, end: 32.2 },
  { word: "com", start: 32.2, end: 32.4 },
  { word: "a", start: 32.4, end: 32.5 },
  { word: "sua", start: 32.5, end: 32.7 },
  { word: "marca", start: 32.7, end: 33.1 },
  { word: "Seu", start: 33.5, end: 33.8 },
  { word: "conteúdo", start: 33.8, end: 34.4 },
  { word: "nunca", start: 34.4, end: 34.8 },
  { word: "mais", start: 34.8, end: 35.1 },
  { word: "vai", start: 35.1, end: 35.3 },
  { word: "ser", start: 35.3, end: 35.5 },
  { word: "o", start: 35.5, end: 35.6 },
  { word: "mesmo", start: 35.6, end: 36.0 },
];

function buildSegments(wordList: typeof words, wordsPerSegment = 10) {
  const segments: Array<{
    words: Array<(typeof words)[number] & { isWithinInterval: true }>;
    startTime: number;
    endTime: number;
    intervalStartTime: number;
  }> = [];

  for (let i = 0; i < wordList.length; i += wordsPerSegment) {
    const chunk = wordList.slice(i, i + wordsPerSegment);
    segments.push({
      words: chunk.map((word) => ({ ...word, isWithinInterval: true as const })),
      startTime: chunk[0].start,
      endTime: chunk[chunk.length - 1].end,
      intervalStartTime: 0,
    });
  }

  return segments;
}

export const BRAND_KIT_PREVIEW_TRANSCRIPTION_SEGMENTS = [buildSegments(words)];
